import { render, staticRenderFns } from "./product_npbkcd6.vue?vue&type=template&id=0b2aef55&scoped=true"
import script from "./product_npbkcd6.vue?vue&type=script&lang=js"
export * from "./product_npbkcd6.vue?vue&type=script&lang=js"
import style0 from "./product_npbkcd6.vue?vue&type=style&index=0&id=0b2aef55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2aef55",
  null
  
)

export default component.exports